module.exports = __webpack_public_path__ + "img/Zu_transportierende_Person.0961e6ce.svg";